/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Crop_Lower_HalfInputs */



/**
* | output |
* | --- |
* | "Lower Half" |
*
* @param {Ocr_Crop_Lower_HalfInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_crop_lower_half = /** @type {((inputs?: Ocr_Crop_Lower_HalfInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Crop_Lower_HalfInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Partie inférieure")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untere Hälfte")
	if (locale === "it") return /** @type {LocalizedString} */ ("metà inferiore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нижняя половина")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mitad inferior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("下半部分")
	if (locale === "ja") return /** @type {LocalizedString} */ ("下半身")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निचला आधा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Metade inferior")
	return /** @type {LocalizedString} */ ("Lower Half")
});